import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=440087f2&scoped=true&"
import script from "./Activation.vue?vue&type=script&lang=js&"
export * from "./Activation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440087f2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/activation/Activation.vue
// module id = 1524
// module chunks = 0